// Step 1 of the Add-a-source wizard. Radio list of adapter types; disabled
// rows for v1.2+ adapters carry a "Coming <tier>" badge per PRD §10.1.

import { ADAPTERS, type SourceType } from "./types";

interface Props {
  value: SourceType | null;
  onChange(t: SourceType): void;
}

export function PickTypeStep({ value, onChange }: Props) {
  return (
    <fieldset className="maisight-sources-pick" aria-label="Pick a source type">
      <legend>Pick a source type</legend>
      <ul className="maisight-sources-pick-list" role="radiogroup">
        {ADAPTERS.map((a) => (
          <li
            key={a.type}
            className={`maisight-sources-pick-row${a.available ? "" : " is-disabled"}`}
          >
            <label>
              <input
                type="radio"
                name="source-type"
                value={a.type}
                checked={value === a.type}
                disabled={!a.available}
                onChange={() => onChange(a.type)}
              />
              <span className="maisight-sources-pick-label">{a.label}</span>
              {a.available ? null : (
                <span className="maisight-sources-pick-badge">Coming {a.tier}</span>
              )}
            </label>
          </li>
        ))}
      </ul>
    </fieldset>
  );
}
